<template>
  <!--头部-->
  <Header :active="activeName"></Header>
  <!--首页banner-->
  <div class="banner">
    <swiper
      :loop="true"
      :autoplay="{
        delay: 5000,
        disableOnInteraction: false,
      }"
      :pagination="{ clickable: true }"
      :navigation="true"
      class="bannerSwiper"
    >
      <swiper-slide v-for="(item, index) in bannerlist" :key="index"
        ><img :src="item" alt=""
      /></swiper-slide>
    </swiper>
    <div class="search_div">
      <div class="search_div_m">
        <div class="search_div_bk">
          <select name="" class="search_select" v-model="searchtype">
            <option value="1">新房</option>
            <option value="2">二手房</option>
            <option value="3">租房</option>
            <option value="4">小区</option>
          </select>
          <input
            type="text"
            class="search_text"
            placeholder="请输入区域、商圈、小区或楼盘名进行搜索"
            v-model="keyword"
          />
          <button type="button" class="search_button" @click="search()">
            <i class="iconfont yswl-sousuo2"></i><span>搜 索</span>
          </button>
        </div>
        <div class="search_div_key">
          <div class="search_key_left">热门楼盘：</div>
          <div class="search_key_right">
            <a
              v-for="(item, index) in hotloupan"
              :key="index"
              @click="showHotDetail(item.id)"
              href="javascript:void(0);"
              >{{ item.name }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--内容区-->
  <section class="container">
    <div class="main">
      <div class="index_bk index_bka">
        <div class="index_bka_left">
          <el-tabs v-model="tabsName" class="index_bka_qh">
            <el-tab-pane label="新房" name="NewHouse">
              <div class="index_bka_div">
                <div class="index_bka_list">
                  <a
                    href="javascript:void(0)"
                    @click="nharea(item.id)"
                    v-for="(item, index) in area"
                    >{{ item.name }}</a
                  >
                  <a href="/nhlist" class="index_bka_more">查看更多</a>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="商业地产" name="RealEstate">
              <div class="index_bka_div">
                <div class="index_bka_list">
                  <a
                    href="javascript:void(0)"
                    @click="buarea(item.id)"
                    v-for="(item, index) in area"
                    >{{ item.name }}</a
                  >
                  <a href="/business" class="index_bka_more">查看更多</a>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="index_bka_right">
          <dd>
            <router-link to="/verification" class="index_bka_link"
              ><img src="@/assets/images/js_1.jpg" alt=""
            /></router-link>
          </dd>
          <dd>
            <router-link to="/mortgage" class="index_bka_link"
              ><img src="@/assets/images/js_2.jpg" alt=""
            /></router-link>
          </dd>
          <dd>
            <router-link to="/taxes" class="index_bka_link"
              ><img src="@/assets/images/js_3.jpg" alt=""
            /></router-link>
          </dd>
        </div>
      </div>
      <!--房源展示-->
      <div class="index_bk index_bkb">
        <div class="index_bk_title">
          房源展示
          <a
            href="/nhlist"
            style="
              font-size: 16px;
              color: #484848;
              font-weight: normal;
              float: right;
            "
            >更多房源 >></a
          >
        </div>

        <div class="index_bkb_m">
          <el-tabs v-model="sourceName" class="index_bkb_qh">
              <el-tab-pane v-for="item in recommend" :label="item.name" :name="item.code">
                  <div class="index_bkb_div">
                      <el-row :gutter="30">
                          <el-col
                                  :span="ListingRecommendation"
                                  v-for="(item, index) in item.list"
                                  style="margin-top: 20px"
                                  :key="index"
                          >
                              <div class="item" style="cursor: pointer">
                                  <a
                                          @click="showHotDetail(item.f_id)"
                                          target="_blank"
                                          class="img"
                                  >
                                      <img style="width:100%" :src="item.house_info.image" :alt="item.house_info.name" />
                                      <div class="txt">
                                          <h5>{{ item.house_info.name }}<span></span></h5>
                                          <div class="sub"></div>
                                          <div class="other">
                                              <div class="price">{{ item.house_info.price }}/㎡</div>
                                          </div>
                                          <div class="tag">当前热推</div>
                                      </div>
                                  </a>
                              </div>
                          </el-col>
                      </el-row>
                  </div>
              </el-tab-pane>
<!--            <el-tab-pane :label="recommend.index_1.name" v-if="recommend.index_1 && recommend.index_1.list" name="HotRealEstate">-->
<!--              <div class="index_bkb_div">-->
<!--                <el-row :gutter="30">-->
<!--                  <el-col-->
<!--                    :span="ListingRecommendation"-->
<!--                    v-for="(item, index) in recommend.index_1.list"-->
<!--                    style="margin-top: 20px"-->
<!--                    :key="item.id"-->
<!--                  >-->
<!--                    <div class="item">-->
<!--                      <a-->
<!--                        @click="showHotDetail(item.f_id)"-->
<!--                        target="_blank"-->
<!--                        class="img"-->
<!--                      >-->
<!--                        <img style="width:100%" :src="item.house_info.image" :alt="item.house_info.name" />-->
<!--                        <div class="txt">-->
<!--                          <h5>{{ item.house_info.district_info.name }}<span></span></h5>-->
<!--                          <div class="sub"></div>-->
<!--                          <div class="other">-->
<!--                            <div class="price">{{ item.house_info.price }}/㎡</div>-->
<!--                          </div>-->
<!--                          <div class="tag">当前热推</div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="热门商铺推荐" name="HotShop">-->
<!--              <div class="index_bkb_div">-->
<!--                <el-row :gutter="30">-->
<!--                  <el-col-->
<!--                    :span="ListingRecommendation"-->
<!--                    v-for="(item, index) in fangyuanlist.rxsp"-->
<!--                    style="margin-top: 20px"-->
<!--                    :key="item.id"-->
<!--                  >-->
<!--                    <div class="item">-->
<!--                      <a-->
<!--                        @click="showHotDetail(item.id)"-->
<!--                        target="_blank"-->
<!--                        class="img"-->
<!--                      >-->
<!--                        <img style="width:100%" :src="item.image" alt="湖州华锦云湖境高清图" />-->
<!--                        <div class="txt">-->
<!--                          <h5>{{ item.address }}<span></span></h5>-->
<!--                          <div class="sub"></div>-->
<!--                          <div class="other">-->
<!--                            <div class="price">{{ item.price }}/㎡</div>-->
<!--                          </div>-->
<!--                          <div class="tag">当前热推</div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div>-->
<!--              &lt;!&ndash; <div class="index_bkb_div">-->
<!--                <el-row :gutter="30">-->
<!--                  <el-col-->
<!--                    :span="ListingRecommendation"-->
<!--                    v-for="item in fangyuanlist.rxsp"-->
<!--                    style="margin-top: 20px"-->
<!--                  >-->
<!--                    <div class="index_bkb_li">-->
<!--                      <a-->
<!--                        @click="showHotDetail(item.id)"-->
<!--                        href="javascript:void(0);"-->
<!--                      >-->
<!--                        <div class="index_bkb_img">-->
<!--                          <img :src="item.image" alt="" />-->
<!--                        </div>-->
<!--                        <div class="index_bkb_info">-->
<!--                          <div class="index_bkb_bt">-->
<!--                            <span class="index_bkb_title"-->
<!--                              >{{ item.zhuangxiu }} {{ item.floor }}-->
<!--                              {{ item.buildYear }}</span-->
<!--                            >-->
<!--                            <span style="height: 44px"-->
<!--                              >地址：{{ item.address }}</span-->
<!--                            >-->
<!--                            <span>{{ item.price }}/平米</span>-->
<!--                          </div>-->
<!--                          <div class="index_bkb_tabs">-->
<!--                            {{ item.title }}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div> &ndash;&gt;-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="上升楼盘推荐" name="UpRealEstate">-->
<!--              <div class="index_bkb_div">-->
<!--                <el-row :gutter="30">-->
<!--                  <el-col-->
<!--                    :span="ListingRecommendation"-->
<!--                    v-for="(item, index) in fangyuanlist.sslp"-->
<!--                    style="margin-top: 20px"-->
<!--                    :key="item.id"-->
<!--                  >-->
<!--                    <div class="item">-->
<!--                      <a-->
<!--                        @click="showHotDetail(item.id)"-->
<!--                        target="_blank"-->
<!--                        class="img"-->
<!--                      >-->
<!--                        <img style="width:100%" :src="item.image" alt="湖州华锦云湖境高清图" />-->
<!--                        <div class="txt">-->
<!--                          <h5>{{ item.address }}<span></span></h5>-->
<!--                          <div class="sub"></div>-->
<!--                          <div class="other">-->
<!--                            <div class="price">{{ item.price }}/㎡</div>-->
<!--                          </div>-->
<!--                          <div class="tag">当前热推</div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
          </el-tabs>
        </div>
      </div>
      <!--楼讯-->
      <div class="index_bk index_bkc">
        <div class="index_bk_title">
          楼讯
          <a
            href="/louxlist"
            style="
              font-size: 16px;
              color: #484848;
              font-weight: normal;
              float: right;
            "
            >更多楼讯 >></a
          >
        </div>
        <div class="index_bkc_m">
          <div
            class="index_bkc_left"
            v-for="(item, index) in louxunlist.slice(0, 1)"
          >
            <div class="index_bkc_info">
              <span
                >{{ item.date }} <img src="@/assets/images/news.png" />
              </span>
              <div class="index_bkc_p">{{ item.title }}</div>
              <a @click="showLxDetail(item.id)" href="javascript:void(0);"
                >查看详情 >
              </a>
            </div>
            <div class="index_bkc_img">
              <img :src="item.image" alt="" />
            </div>
          </div>
          <div class="index_bkc_right">
            <dd v-for="(item, index) in louxunlist.slice(1, 4)" :key="index">
              <span>{{ item.date }}</span>
              <div class="index_bkc_rp">{{ item.title }}</div>
              <a @click="showLxDetail(item.id)" href="javascript:void(0);"
                >查看详情 >
              </a>
            </dd>
          </div>
        </div>
      </div>
      <!--特色推荐-->
      <div class="index_bk index_bkd">
        <div class="index_bk_title">
          新房特价专区
          <a
            href="/special"
            style="
              font-size: 16px;
              color: #484848;
              font-weight: normal;
              float: right;
            "
            >更多特价专区 >></a
          >
        </div>
        <div class="index_bkd_m" @mouseleave="bkdm(1)">
          <dd
            :class="addName == 0 ? 'on' : ''"
            @mouseover="bkdver(0)"
            v-if="tejialist"
          >
            <div class="index_bkd_img">
              <img
                :src="tejialist[0].image_oss"
                alt=""
                style="max-width: 100%; height: 100%"
              />
            </div>
            <div class="index_bkd_info">
              <div class="index_bkd_bh">
                <img src="@/assets/images/bh_1.png" alt="" />
              </div>
              <div class="index_bkd_ceng">
                <p>{{ tejialist[0].title }}</p>
                <a
                  @click="showTejiaDetail(tejialist[0].id)"
                  href="javascript:void(0);"
                  class="index_bkd_a"
                  >查看详情</a
                >
              </div>
            </div>
          </dd>
          <dd
            :class="addName == 1 ? 'on' : ''"
            @mouseover="bkdver(1)"
            v-if="tejialist"
          >
            <div class="index_bkd_img">
              <img
                style="max-width: 100%; height: 100%"
                :src="tejialist[1].image_oss"
                alt=""
              />
            </div>
            <div class="index_bkd_info">
              <div class="index_bkd_bh">
                <img src="@/assets/images/bh_2.png" alt="" />
              </div>
              <div class="index_bkd_ceng">
                <p>{{ tejialist[1].title }}</p>
                <a
                  @click="showTejiaDetail(tejialist[1].id)"
                  href="javascript:void(0);"
                  class="index_bkd_a"
                  >查看详情</a
                >
              </div>
            </div>
          </dd>
          <dd
            :class="addName == 2 ? 'on' : ''"
            @mouseover="bkdver(2)"
            v-if="tejialist"
          >
            <div class="index_bkd_img">
              <img
                style="max-width: 100%; height: 100%"
                :src="tejialist[2].image_oss"
                alt=""
              />
            </div>
            <div class="index_bkd_info">
              <div class="index_bkd_bh">
                <img src="@/assets/images/bh_3.png" alt="" />
              </div>
              <div class="index_bkd_ceng">
                <p>{{ tejialist[2].title }}</p>
                <a
                  @click="showTejiaDetail(tejialist[2].id)"
                  href="javascript:void(0);"
                  class="index_bkd_a"
                  >查看详情</a
                >
              </div>
            </div>
          </dd>
          <dd
            :class="addName == 3 ? 'on' : ''"
            @mouseover="bkdver(3)"
            v-if="tejialist"
          >
            <div class="index_bkd_img">
              <img
                style="max-width: 100%; height: 100%"
                :src="tejialist[3].image_oss"
                alt=""
              />
            </div>
            <div class="index_bkd_info">
              <div class="index_bkd_bh">
                <img src="@/assets/images/bh_4.png" alt="" />
              </div>
              <div class="index_bkd_ceng">
                <p>{{ tejialist[3].title }}</p>
                <a
                  @click="showTejiaDetail(tejialist[3].id)"
                  href="javascript:void(0);"
                  class="index_bkd_a"
                  >查看详情</a
                >
              </div>
            </div>
          </dd>
        </div>
      </div>
      <!--个性选房-->
      <div class="index_bk index_bke">
        <div class="index_bk_title">个性选房</div>
        <div class="index_bke_m">
          <div class="index_bke_a">
            <div class="index_bke_num">
              <div class="index_bke_li">
                <dd>
                  <a href="javascript:;"
                    ><span>出租房源</span><span>{{ tongji.leaseNum }}</span></a
                  >
                </dd>
                <dd>
                  <a href="javascript:;"
                    ><span>出售房源</span><span>{{ tongji.saleNum }}</span></a
                  >
                </dd>
              </div>
              <div class="index_bke_li">
                <dd>
                  <a href="javascript:;"
                    ><span>新盘房源</span
                    ><span>{{ tongji.businessNum }}</span></a
                  >
                </dd>
                <dd>
                  <a href="javascript:;"
                    ><span>小区数量</span
                    ><span>{{ tongji.commentNum }}</span></a
                  >
                </dd>
              </div>
              <div class="index_bke_li">
                <dd>
                  <a href="javascript:;"
                    ><span>经纪人</span><span>{{ tongji.employeeNum }}</span></a
                  >
                </dd>
                <dd>
                  <a href="javascript:;"
                    ><span>装修公司数量</span
                    ><span>{{ tongji.viewNum }}</span></a
                  >
                </dd>
              </div>
            </div>
            <div class="index_bke_imga">
              <a href="" :style="{ backgroundImage: 'url(' + gximg + ')' }"></a>
            </div>
          </div>
          <!--					<div class="index_bke_b">-->
          <!--						<dd v-for="(t,index) in gximglist" :key="index"><a :href="t.url" :style="{backgroundImage:'url('+t.imgurl+')'}"></a></dd>-->
          <!--					</div>		-->
        </div>
      </div>
    </div>
  </section>

  <!--	<section class="links">-->
  <!--		<div class="links_m">-->
  <!--			<div class="links_left">-->
  <!--				<div class="links_left_title">友情链接</div>-->
  <!--				<div class="links_left_a">-->
  <!--					<a href="" target="_blank">广告部</a>-->
  <!--					<a href="" target="_blank">企宣部</a>-->
  <!--					<a href="" target="_blank">关于我们</a>-->
  <!--				</div>-->
  <!--			</div>-->
  <!--			<div class="links_right">-->
  <!--				<dd><a href="">热门城市</a></dd>-->
  <!--				<dd><a href="">周边城市</a></dd>-->
  <!--			</div>-->
  <!--		</div>-->
  <!--	</section>-->

  <!--底部-->
  <Footer></Footer>
  <!--浮动客服-->
  <OnlineMsg></OnlineMsg>
</template>

<script>
import "@/assets/css/index.css";
import { ref } from "vue";
//公共文件 头部/底部
import Header from "@/components/public/Header.vue";
import Footer from "@/components/public/Footer.vue";
import OnlineMsg from "@/components/public/OnlineMsg.vue";
//导入swiper中vue组件
import { Swiper, SwiperSlide } from "swiper/vue";
//导入swiper模块
import SwiperBanner, {
  Pagination,
  Navigation,
  EffectCoverflow,
  Autoplay,
} from "swiper";
//接口
import axios from "axios";
import global from "@/global";
import Api from "@/api/api"

SwiperBanner.use([Pagination, Navigation, EffectCoverflow, Autoplay]);

export default {
  name: "Index",
  components: {
    Header,
    Footer,
    OnlineMsg,
    Swiper,
    SwiperSlide,
  },
  setup() {
    //导航高亮标识
    const activeName = ref("home");

    //新房-商业地产 切换默认
    const tabsName = ref("NewHouse");
    //房源展示-切换默认
    const sourceName = ref("index_1");

    //特色推荐
    const addName = ref(0);
    //特色推荐 - 移出父级区域恢复初始设置
    const bkdver = (index) => {
      addName.value = index;
    };
    //特色推荐 - 移入当前子元素 高亮
    const bkdm = (index) => {
      if (index == 1) {
        addName.value = 0;
      }
    };

    return {
      activeName,
      tabsName,
      sourceName,
      addName,
      bkdm,
      bkdver,
    };
  },
  data() {
    return {
      ListingRecommendation:6,
      area: [],
      keyword: "",
      searchtype: 1,
      hotloupan: [],
      globalUrl: global.httpUrl,
      //首页banner
      bannerlist: [
      //   	require('@/assets/images/banner1.jpg'),
			// //  require('@/assets/images/banner2.jpg'),
			//  require('@/assets/images/banner3.jpg'),
        // { imgurl: require("@/assets/images/banner.jpg") },
        // { imgurl: require("@/assets/images/banner.jpg") },
        // { imgurl: require("@/assets/images/banner.jpg") },
      ],
      tejialist: [{}, {}, {}, {}],
      louxunlist: [],
      fangyuanlist: [],
      //个性选房图1
      gximg: require("@/assets/images/a_7.jpg"),
      //个性选房下三图
      gximglist: [
        { url: "/", imgurl: require("@/assets/images/a_8.jpg") },
        { url: "/", imgurl: require("@/assets/images/a_9.jpg") },
        { url: "/", imgurl: require("@/assets/images/a_9.jpg") },
      ],
      tongji: [],
      recommend: {}
    };
  },
  //   computed:{
  // 	fangyuanlistrmtj(){
  //          return  fangyuanlist.rmtj.slice(0,14)
  //      }

  //   },
  //在组件被挂载之前调用
  created() {
    console.log(document.documentElement.clientWidth);
    // if(document.documentElement.clientWidth<850){
    //   this.ListingRecommendation=12
    // }
    // else if(document.documentElement.clientWidth<1100){
    //   this.ListingRecommendation=8
    // }
    //console.log(this.bannerlist);
    this.getlouxun();
    this.getfangyuan();
    this.gettongji();
    this.gettejia();
    this.getbanner();
    this.gethot();
    this.getarea();
    Api.Index.recommend("index_1,index_2,index_3").then(res => {
        this.recommend = res;
    })
    document.title = "湖州有房网";
  },
  //在组件被挂载之后调用。
  mounted() {},
  methods: {
    handleGo() {
      let { href } = this.$router.resolve({
        path: "/demo/study",
        query: {
          name: "天气有点热",
        },
      });
      window.open(href, "_blank");
    },
    nharea(areaid) {
      this.$router.push({
        path: `/nhlist/`,
        query: {
          district_id: areaid,
        },
      });
    },
    buarea(areaid) {
      this.$router.push({
        path: `/business/`,
        query: {
          district_id: areaid,
        },
      });
    },
    showLxDetail(id) {
      this.$router.push({
        path: `/louxunshow/` + id,
      });
    },
    getarea() {
      const that = this;
      axios
        .get(this.globalUrl + "/api/home/getDistrict")
        .then(function (response) {
          if (response.data.code == 1) {
            //console.log('response.data',response.data.data)
            that.area = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    search() {
      if (this.keyword == "" || this.keyword == undefined) {
        this.$message({
          showClose: true,
          message: "请输入搜索关键词",
          type: "error",
          duration: 2000,
          center: true,
          offset: 150,
        });
        return false;
      }

      if (this.searchtype == 1) {
        this.$router.push({
          path: "/nhlist",
          query: {
            keyword: this.keyword,
          },
        });
      }
      //二手房
      if (this.searchtype == 2) {
        this.$router.push({
          path: "/esf",
          query: {
            keyword: this.keyword,
          },
        });
      }
      //租房
      if (this.searchtype == 3) {
        this.$router.push({
          path: "/lease",
          query: {
            keyword: this.keyword,
          },
        });
      }
      //小区
      if (this.searchtype == 4) {
        this.$router.push({
          path: "/community",
          query: {
            keyword: this.keyword,
          },
        });
      }
    },
    showHotDetail(id) {
      this.$router.push({
        path: `/nhshow/` + id,
      });
    },
    gethot() {
      const that = this;
      axios
        .get(this.globalUrl + "/api/home/getHotLoupan")
        .then(function (response) {
          if (response.data.code == 1) {
            //console.log('response.data',response.data.data)
            that.hotloupan = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getbanner() {
      const that = this;
      axios
        // .get(this.globalUrl + "/api/home/getAd?code=banner")
        .get(this.globalUrl + "/api/home/getBanner?local=8")
        .then(function (response) {
          if (response.data.code == 1) {
            console.log("response.data", response.data.data);
            that.bannerlist = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showTejiaDetail(id) {
      this.$router.push({
        path: `/specialshow/` + id,
      });
    },
    showDetail(id) {
      this.$router.push({
        path: `/nhlist/` + id,
      });
    },
    //特价房
    gettejia() {
      const that = this;
      axios
        .get(this.globalUrl + "/api/home/getTejiaList?page=1")
        .then(function (response) {
          if (response.data.code == 1) {
            that.tejialist = response.data.data.list;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //楼讯
    getlouxun() {
      const that = this;
      axios
        .get(this.globalUrl + "/api/home/getRecommendArticle")
        .then(function (response) {
          if (response.data.code == 1) {
            that.louxunlist = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //房源
    getfangyuan() {
      const that = this;
      axios
        .get(this.globalUrl + "/api/home/getRecommendHouse")
        .then(function (response) {
          if (response.data.code == 1) {
            that.fangyuanlist = response.data.data;
            //   that.fangyuanlist.rmtj.push(...that.fangyuanlist.rmtj)
            //   that.fangyuanlist.rmtj.push(...that.fangyuanlist.rmtj)
            that.fangyuanlist.rmtj = that.fangyuanlist.rmtj.slice(0, 12);
            that.fangyuanlist.rxsp = that.fangyuanlist.rxsp.slice(0, 12);
            that.fangyuanlist.sslp = that.fangyuanlist.sslp.slice(0, 12);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //统计
    gettongji() {
      const that = this;
      axios
        .get(this.globalUrl + "/api/home/getHomeTongji")
        .then(function (response) {
          if (response.data.code == 1) {
            that.tongji = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped >
.banner {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.bannerSwiper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.bannerSwiper .swiper-slide {
  height: 100%;
  height: 100%;
}
.bannerSwiper .swiper-slide img {
  display: block;
  width: 100%;
}

:deep(.bannerSwiper .swiper-pagination-bullet) {
  width: 16px;
  height: 16px;
}

:deep(.bannerSwiper .swiper-pagination-bullet.swiper-pagination-bullet-active) {
  background: #ff9d66;
}

.search_div {
  width: 100%;
  position: absolute;
  left: 0;
  /* bottom: 60px; */
  bottom: 43px;
}
.search_div_m {
  position: relative;
  max-width: 1200px;
  margin: auto;
  z-index: 1;
}

.search_div_bk {
  display: flex;
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-radius: 5px;
		margin-bottom: 20px;
		/* margin-bottom: 14px; */
		overflow: hidden;
		position: relative;
}
.search_select {
  width: 210px;
  height: 100%;
  border: none;
  border-right: solid 1px #cccccc;
  padding: 0 15px 0 20px;
  margin-top: -1px;
  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  /*在选择框的最右侧中间显示小箭头图片*/
  background: url(@/assets/images/ico_jt_1.png) right 20px center no-repeat;
  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  color: #505050;
  font-size: 16px;
}
.search_text {
  min-width: 790px;
  height: 100%;
  border: none;
  padding: 0 20px;
  font-size: 16px;
}
.search_text::placeholder {
  font-size: 16px;
}
.search_button {
  width: 200px;
  height: 100%;
  background: #ff9d66;
  color: #ffffff;
  border: none;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search_button i.iconfont {
  font-size: 16px;
  font-weight: 600;
  margin-right: 8px;
}

.search_div_key {
  width: 100%;
  display: -ms-flexbox;
  display: flex;
}
.search_key_left {
  display: inline-block;
  font-size: 18px;
  /* color: rgba(255, 255, 255, 0.5); */
  color: white;
}
.search_key_right {
  display: inline-block;
  font-size: 18px;
  /* color: rgba(255, 255, 255, 0.5); */
  color: white;
}
.search_key_right a {
  margin-right: 12px;
  font-size: 18px;
  /* color: rgba(255, 255, 255, 0.5); */
  color: white;
}
.search_key_right a:hover {
  color: #ff9d66;
}
.item {
  width: 280px;
  margin-left: 20px;
  float: left;
  position: relative;
  margin-bottom: 20px;
}
.item .img {
  display: block;
  width: 280px;
  height: 170px;
  overflow: hidden;
  position: relative;
}
.item .txt {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -26px;
  background: #000;
  background: rgba(0, 0, 0, 0.7);
  filter: alpha(opacity=70);
  padding: 8px 0;
  transition: bottom 0.5s;
  -webkit-transition: bottom 0.5s;
  -moz-transition: bottom 0.5s;
  -ms-transition: bottom 0.5s;
}
.item .txt h5 {
  font-size: 18px;
  color: #fff;
  line-height: 20px;
  margin: 0 16px;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item .sub {
  color: #ccc;
  line-height: 20px;
  margin: 4px 16px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item .other {
  overflow: hidden;
  margin: 4px 16px 0;
}
.item .price {
  float: left;
  color: #e95c0d;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
}
.item .tag {
  margin: 0 16px;
  color: #fff;
  line-height: 20px;
}
.item:after {
  /*content: "广告";*/
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  font-size: 10px;
  color: #fff;
  background: #000;
  line-height: 14px;
  padding: 0 1px;
  background: rgba(0, 0, 0, 0.2);
  filter: alpha(opacity=20);
}
.item:hover .txt {
  bottom: 0px;
}

</style>
